import React from 'react';

import { InputProps } from '@material-ui/core/Input';

export const CharAmount = ({ inputProps, value, className }: InputProps) => {
  const max: number | null =
    inputProps && (inputProps.max || inputProps.maxLength)
      ? inputProps.max
        ? inputProps.max
        : inputProps.maxLength
      : null;

  return max ? (
    <p className={`char-amount ${className}`}>
      {`${value && String(value).length > 0 ? String(value).length : 0} / ${max} characters`}
    </p>
  ) : (
    <div />
  );
};
